import _objectWithoutProperties from "/home/runner/work/Project-Evo/Project-Evo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties";
import _objectSpread from "/home/runner/work/Project-Evo/Project-Evo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectSpread2";
import _objectDestructuringEmpty from "/home/runner/work/Project-Evo/Project-Evo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectDestructuringEmpty";
var _excluded = ["fillColor", "strokeColor", "strokeWidth", "size"];
import { jsx, jsxs, Fragment } from 'react/jsx-runtime';
import { forwardRef } from 'react';
import { withSubcomponents } from '../utils.js';
var Path = function Path(_ref) {
  var args = Object.assign({}, (_objectDestructuringEmpty(_ref), _ref));
  return /* @__PURE__ */jsxs(Fragment, {
    children: [/* @__PURE__ */jsx("path", _objectSpread({
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M19.5761 48.2771L18.9522 48.9009L19.576 48.2771L19.5761 48.2771ZM14.2185 32.9976V9.12498\n         C14.2185 8.57269 14.6663 8.12498 15.2185 8.12498H48.7654C48.8058 8.12498 48.8456 8.12737 48.8847 8.13202\n         L43.8066 13.2101C43.7675 13.2055 43.7276 13.2031 43.6873 13.2031H20.2967C19.7444 13.2031 19.2967 13.6508 19.2967 14.2031\n         V19.3463C19.2967 19.6788 19.4619 19.9896 19.7376 20.1754L29.9536 27.0631L18.6964 38.3203\n         C18.4794 38.1873 18.2663 38.0487 18.0579 37.9063L18.3386 37.1177L14.2185 32.9976ZM49.7654 23.2174\n         V43.7893C49.7654 44.722 49.3316 45.6016 48.5916 46.1694L31.992 58.9062L28.229 56.019L34.8677 53.6467\n         L27.867 46.646L27.0853 46.9299C26.9457 46.7253 26.8099 46.5162 26.6794 46.3034L49.7654 23.2174Z"
    }, args)), /* @__PURE__ */jsx("path", _objectSpread({
      d: "M22.4021 40.9289L23.9114 41.0886L24.0711 42.5979C24.1317 43.1598 24.2584 43.7106 24.4291 44.245\n         L56.0364 12.6377L58.9062 6.09375L52.3623 8.96363L20.755 40.5709C21.2894 40.7416 21.8457 40.8683 22.4021 40.9289Z\n         M26.0376 50.5521C24.5063 48.7784 22.5398 45.947 22.2038 42.7962C19.0529 42.4602 16.2216 40.4937 14.4479 38.9624\n         L14.8225 37.9103L12.5971 35.6849L11.1208 39.8162L11.8975 40.5984L13.3407 42.0416L16.3043 45.0051L16.7174 45.4182\n         L15.3899 46.7458L7.25945 54.8762L6.40565 54.0224L5.07812 55.3554L6.08616 58.9138L9.64459 59.9219L10.9721 58.5943\n         L10.1183 57.735L18.2487 49.6046L19.5762 48.2771L19.9894 48.6847L22.9529 51.6482L24.3961 53.0915L25.1783 53.8736\n         L29.3096 52.3974L27.0842 50.172L26.0376 50.5521Z"
    }, args))]
  });
};
var ViewBox = "0 0 65 65";
var _FWSupport = forwardRef(function (_ref2, ref) {
  var _ref2$fillColor = _ref2.fillColor,
    fillColor = _ref2$fillColor === void 0 ? "white" : _ref2$fillColor,
    _ref2$strokeColor = _ref2.strokeColor,
    strokeColor = _ref2$strokeColor === void 0 ? "black" : _ref2$strokeColor,
    _ref2$strokeWidth = _ref2.strokeWidth,
    strokeWidth = _ref2$strokeWidth === void 0 ? 0 : _ref2$strokeWidth,
    _ref2$size = _ref2.size,
    size = _ref2$size === void 0 ? 65 : _ref2$size,
    rest = _objectWithoutProperties(_ref2, _excluded);
  return /* @__PURE__ */jsx("svg", _objectSpread(_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    width: size,
    height: size,
    viewBox: ViewBox,
    fill: "none",
    paintOrder: "stroke"
  }, rest), {}, {
    children: /* @__PURE__ */jsx(Path, {
      fill: fillColor,
      stroke: strokeColor,
      strokeWidth: strokeWidth
    })
  }));
});
_FWSupport.displayName = "FWSupport";
var FWSupport = withSubcomponents(_FWSupport, {
  Path: Path,
  ViewBox: ViewBox
});
export { FWSupport };